module.exports = __webpack_public_path__ + "img/icon-yunjiao.2337813a.png";